var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("body", { class: { unselectable: _vm.resizingIndex != null } }, [
    _c("div", { staticClass: "half-screen", style: { width: _vm.widths[0] } }, [
      _c("div", {
        staticClass: "resize-handle",
        on: {
          mousedown: function($event) {
            return _vm.startResize(0)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "tablecontainer full" }, [
        _c("table", [
          _vm.emails_data != null
            ? _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { colspan: "2" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "emailtable",
                        staticStyle: { "margin-bottom": "10px" }
                      },
                      [
                        _c("p", [_vm._v("Emails")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.term,
                              expression: "term"
                            }
                          ],
                          staticStyle: { "margin-right": "0px" },
                          domProps: { value: _vm.term },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.searchEmails()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.term = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.searchEmails()
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "search" }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "emailtable",
                        staticStyle: { width: "100%" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nocontacts,
                              expression: "nocontacts"
                            }
                          ],
                          staticStyle: { width: "15px", "margin-right": "5px" },
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.nocontacts)
                              ? _vm._i(_vm.nocontacts, null) > -1
                              : _vm.nocontacts
                          },
                          on: {
                            click: function($event) {
                              return _vm.nextTickSearch()
                            },
                            change: function($event) {
                              var $$a = _vm.nocontacts,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.nocontacts = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.nocontacts = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.nocontacts = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "emailtabletext" }, [
                          _vm._v("No Contacts")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nojoborders,
                              expression: "nojoborders"
                            }
                          ],
                          staticStyle: { width: "15px", "margin-right": "5px" },
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.nojoborders)
                              ? _vm._i(_vm.nojoborders, null) > -1
                              : _vm.nojoborders
                          },
                          on: {
                            click: function($event) {
                              return _vm.nextTickSearch()
                            },
                            change: function($event) {
                              var $$a = _vm.nojoborders,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.nojoborders = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.nojoborders = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.nojoborders = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "emailtabletext" }, [
                          _vm._v("No Job Orders")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "emailtabletext" }, [
                          _vm._v("From")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fromdate,
                              expression: "fromdate"
                            }
                          ],
                          staticStyle: { height: "30px", width: "150px" },
                          attrs: { id: "fromdate", type: "date" },
                          domProps: { value: _vm.fromdate },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.fromdate = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "emailtabletext" }, [
                          _vm._v("To")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.todate,
                              expression: "todate"
                            }
                          ],
                          staticStyle: { height: "30px", width: "150px" },
                          attrs: { id: "todate", type: "date" },
                          domProps: { value: _vm.todate },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.todate = $event.target.value
                            }
                          }
                        })
                      ]
                    )
                  ])
                ])
              ])
            : _c("thead", [_vm._m(0)]),
          _vm._v(" "),
          _vm.emails_data != null
            ? _c(
                "tbody",
                [
                  _vm._l(_vm.emails_data, function(data, col) {
                    return _c(
                      "tr",
                      {
                        class: { selected: _vm.emailId == data[0] },
                        staticStyle: { border: "1px solid #ddd" },
                        on: {
                          click: function($event) {
                            return _vm.getEmail(col)
                          }
                        }
                      },
                      [
                        _c("td", { staticStyle: { border: "none" } }, [
                          _c("div", { staticStyle: { margin: "0px" } }, [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  margin: "0px",
                                  "word-break": "break-all",
                                  height: "20px",
                                  overflow: "hidden",
                                  "font-size": "18px"
                                }
                              },
                              [_vm._v(_vm._s(data[4]))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  margin: "0px",
                                  "word-break": "break-all",
                                  height: "20px",
                                  overflow: "hidden",
                                  "font-weight": "bold",
                                  color: "#106EBE",
                                  "font-size": "14px"
                                }
                              },
                              [_vm._v(_vm._s(data[6]) + ": " + _vm._s(data[2]))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "margin-bottom": "5px",
                                  "word-break": "break-all",
                                  height: "15px",
                                  overflow: "hidden",
                                  "font-size": "10px"
                                }
                              },
                              [_vm._v(_vm._s(data[5]))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "0px",
                              border: "none",
                              "vertical-align": "top"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      height: "20px",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    data[8] == 0
                                      ? _c("font-awesome-icon", {
                                          staticStyle: {
                                            width: "15px",
                                            height: "15px",
                                            color: "red",
                                            float: "right"
                                          },
                                          attrs: { icon: "circle" }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data[9] != 0
                                      ? _c("font-awesome-icon", {
                                          staticStyle: {
                                            width: "15px",
                                            height: "15px",
                                            color: "gray",
                                            float: "right"
                                          },
                                          attrs: { icon: "paperclip" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      margin: "0px 10px 0px 10px",
                                      "white-space": "nowrap",
                                      "font-weight": "bold",
                                      color: "#106EBE",
                                      "font-size": "14px"
                                    }
                                  },
                                  [_vm._v(_vm._s(data[1].substr(0, 16)))]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "2" } }, [
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.loadMore()
                            }
                          }
                        },
                        [_vm._v("Load More")]
                      )
                    ])
                  ])
                ],
                2
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "half-screen", style: { width: _vm.widths[1] } }, [
      _c("div", {
        staticClass: "resize-handle",
        on: {
          mousedown: function($event) {
            return _vm.startResize(1)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tablecontainer full",
          staticStyle: { "padding-right": "8px" }
        },
        [
          _vm.resizingIndex != null
            ? _c("div", { staticClass: "iframeCover" })
            : _vm._e(),
          _vm._v(" "),
          _vm.selectIndex != null
            ? _c(
                "div",
                { staticStyle: { "overflow-y": "scroll", height: "100%" } },
                [
                  _c("div", { staticClass: "emailheader" }, [
                    _vm._v(_vm._s(_vm.emails_data[_vm.selectIndex][4]))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "emailheader" }, [
                    _vm._v(
                      "Date: " + _vm._s(_vm.emails_data[_vm.selectIndex][1])
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "emailheader" }, [
                    _vm._v(
                      "From: " + _vm._s(_vm.emails_data[_vm.selectIndex][2])
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "emailheader" }, [
                    _vm._v("To: " + _vm._s(_vm.emails_data[_vm.selectIndex][3]))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "emailheader" }, [
                    _vm._v(
                      "Acc: " + _vm._s(_vm.emails_data[_vm.selectIndex][6])
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "emailheader",
                      staticStyle: {
                        "max-height": "100px",
                        "overflow-y": "scroll"
                      }
                    },
                    [
                      _vm._v(
                        "CC: " + _vm._s(_vm.emails_data[_vm.selectIndex][7])
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr", { staticStyle: { width: "100%" } }),
                  _vm._v(" "),
                  _vm.emailHtml
                    ? _c("iframe", {
                        ref: "emailFrame",
                        staticStyle: { width: "100%", flex: "1" }
                      })
                    : _c("div", [_vm._v("Loading Email")])
                ]
              )
            : _c("div", [_vm._v("No Email Selected")])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "half-screen", style: { width: _vm.widths[2] } }, [
      _c(
        "div",
        {
          staticClass: "tablecontainer half",
          staticStyle: { "overflow-x": "scroll" }
        },
        [
          _c("table", [
            _vm.emailcontacts_data != null && _vm.emailcontacts_data.length > 0
              ? _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      { attrs: { colspan: _vm.emailcontacts_data[0].length } },
                      [
                        _vm._v("Email Contacts "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactterm,
                              expression: "contactterm"
                            }
                          ],
                          domProps: { value: _vm.contactterm },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.searchEmailContacts()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.contactterm = $event.target.value
                            }
                          }
                        }),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.searchEmailContacts()
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "search" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c("th", { staticStyle: { width: "30px" } }),
                      _vm._v(" "),
                      _vm._l(_vm.emailcontacts_names, function(name, i) {
                        return i > 0
                          ? _c("th", [_vm._v(_vm._s(name))])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _c("thead", [_vm._m(1)]),
            _vm._v(" "),
            _vm.emailcontacts_data != null
              ? _c(
                  "tbody",
                  _vm._l(_vm.emailcontacts_data, function(data, col) {
                    return _c(
                      "tr",
                      { on: { click: function($event) {} } },
                      [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailcontacts_checks[col],
                                expression: "emailcontacts_checks[col]"
                              }
                            ],
                            staticStyle: { width: "30px" },
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.emailcontacts_checks[col]
                              )
                                ? _vm._i(_vm.emailcontacts_checks[col], null) >
                                  -1
                                : _vm.emailcontacts_checks[col]
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.emailcontacts_checks[col],
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.emailcontacts_checks,
                                          col,
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.emailcontacts_checks,
                                          col,
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.emailcontacts_checks, col, $$c)
                                  }
                                },
                                function($event) {
                                  return _vm.setContact(col)
                                }
                              ]
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm._l(data, function(val, i) {
                          return i > 0
                            ? _c("td", [_c("p", [_vm._v(_vm._s(val))])])
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tablecontainer half",
          staticStyle: { "overflow-x": "scroll" }
        },
        [
          _c("table", [
            _vm.emailjoborders_data != null &&
            _vm.emailjoborders_data.length > 0
              ? _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      { attrs: { colspan: _vm.emailjoborders_data[0].length } },
                      [
                        _vm._v("Email Job Orders "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.joborderterm,
                              expression: "joborderterm"
                            }
                          ],
                          domProps: { value: _vm.joborderterm },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.searchEmailJoborders()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.joborderterm = $event.target.value
                            }
                          }
                        }),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.searchEmailJoborders()
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "search" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c("th", { staticStyle: { width: "30px" } }),
                      _vm._v(" "),
                      _vm._l(_vm.emailjoborders_names, function(name, i) {
                        return i > 0
                          ? _c("th", [_vm._v(_vm._s(name))])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _c("thead", [_vm._m(2)]),
            _vm._v(" "),
            _vm.emailjoborders_data != null
              ? _c(
                  "tbody",
                  _vm._l(_vm.emailjoborders_data, function(data, col) {
                    return _c(
                      "tr",
                      { on: { click: function($event) {} } },
                      [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailjoborders_checks[col],
                                expression: "emailjoborders_checks[col]"
                              }
                            ],
                            staticStyle: { width: "30px" },
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.emailjoborders_checks[col]
                              )
                                ? _vm._i(_vm.emailjoborders_checks[col], null) >
                                  -1
                                : _vm.emailjoborders_checks[col]
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.emailjoborders_checks[col],
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.emailjoborders_checks,
                                          col,
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.emailjoborders_checks,
                                          col,
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.emailjoborders_checks,
                                      col,
                                      $$c
                                    )
                                  }
                                },
                                function($event) {
                                  return _vm.setJoborder(col)
                                }
                              ]
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm._l(data, function(val, i) {
                          return i > 0
                            ? _c("td", [
                                i == 1
                                  ? _c("p", [
                                      _vm._v(
                                        "11-" +
                                          _vm._s(("00000" + val).substr(-5))
                                      )
                                    ])
                                  : _c("p", [_vm._v(_vm._s(val))])
                              ])
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "table-header", attrs: { colspan: "3" } }, [
        _vm._v("Table Empty")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "table-header" }, [_vm._v("Table Empty")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "table-header" }, [_vm._v("Table Empty")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63e15d8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e15d8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file/Emails.vue
// module id = 748
// module chunks = 0